import { Dropdown } from '@silverfort/sf-components';
import { FilterVariantProps } from '@silverfort/sf-components/dist/Dropdown/interfaces';
import { ReactNode } from 'react';

interface Props<T> {
    options: FilterVariantProps<T>[];
    customFilters?: ReactNode[];
}

const Filters = <T,>({ options, customFilters }: Props<T>) => {
    return (
        <div className="w-[80%] h-fit flex flex-wrap gap-2">
            {options.map((filter, index) => {
                const isItemRemovable = Array.isArray(filter.selectedItems) ? filter.selectedItems.length > 0 : false;
                return (
                    <Dropdown
                        {...filter}
                        key={filter.text ?? index}
                        onChange={filter.onChange as (val?: unknown | unknown[]) => void}
                        onRemove={() => filter.onChange?.(undefined)}
                        removable={isItemRemovable}
                        multiple
                        searchable
                    />
                );
            })}
            {customFilters}
        </div>
    );
};

export default Filters;
